import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Pipe({ name: 'sortChats', standalone: true })
@Injectable({providedIn: 'root'})
export class SortChatsPipe implements PipeTransform {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	transform(items) {
		var filtered: Array<any> = [];
		this.angularHelperService.forEach(items, function(item) {
			filtered.push(item);
		});
		filtered.sort(function(a, b) {
			return (a.lastPost.id < b.lastPost.id ? 1 : -1);
		});
		
		return filtered;
	}
	
}